import bg1 from '../../../assets/imgs/backgrounds/pattern_1.png';
import bg2 from '../../../assets/imgs/backgrounds/pattern_2.png';
import bg3 from '../../../assets/imgs/backgrounds/pattern_3.png';
import bg4 from '../../../assets/imgs/backgrounds/pattern_4.png';
import bg5 from '../../../assets/imgs/backgrounds/pattern_5.png';
import bg6 from '../../../assets/imgs/backgrounds/pattern_6.png';
import bg7 from '../../../assets/imgs/backgrounds/pattern_7.png';
import bg8 from '../../../assets/imgs/backgrounds/pattern_8.png';
import bg9 from '../../../assets/imgs/backgrounds/pattern_9.png';
import bg10 from '../../../assets/imgs/backgrounds/pattern_10.png';
import bg11 from '../../../assets/imgs/backgrounds/pattern_11.png';
import bg12 from '../../../assets/imgs/backgrounds/pattern_12.png';
import bg13 from '../../../assets/imgs/backgrounds/pattern_13.png';
import bg14 from '../../../assets/imgs/backgrounds/pattern_14.png';
import bg15 from '../../../assets/imgs/backgrounds/pattern_15.png';
import bg16 from '../../../assets/imgs/backgrounds/pattern_16.png';
import bg17 from '../../../assets/imgs/backgrounds/pattern_17.png';
import bg18 from '../../../assets/imgs/backgrounds/pattern_18.png';
import bg19 from '../../../assets/imgs/backgrounds/pattern_19.png';
import bg20 from '../../../assets/imgs/backgrounds/pattern_20.png';
import bg21 from '../../../assets/imgs/backgrounds/pattern_21.png';
import bg22 from '../../../assets/imgs/backgrounds/pattern_22.png';
import bg23 from '../../../assets/imgs/backgrounds/pattern_23.png';
import bg24 from '../../../assets/imgs/backgrounds/pattern_24.png';
import bg25 from '../../../assets/imgs/backgrounds/pattern_25.png';
import bg26 from '../../../assets/imgs/backgrounds/pattern_26.png';
import bg27 from '../../../assets/imgs/backgrounds/pattern_27.png';
import bg28 from '../../../assets/imgs/backgrounds/pattern_28.png';
import bg29 from '../../../assets/imgs/backgrounds/pattern_29.png';
import bg30 from '../../../assets/imgs/backgrounds/pattern_30.png';
import bg31 from '../../../assets/imgs/backgrounds/pattern_31.png';
import bg32 from '../../../assets/imgs/backgrounds/pattern_32.png';
import bg33 from '../../../assets/imgs/backgrounds/pattern_33.png';
import bg34 from '../../../assets/imgs/backgrounds/pattern_34.png';
import bg35 from '../../../assets/imgs/backgrounds/pattern_35.png';
import bg36 from '../../../assets/imgs/backgrounds/pattern_36.png';

const backgrounds = {
  values: [
    { id: 0, src: '', repeat: true },
    // {
    //   id: 1,
    //   src: bg1,
    // repeat:true,
    // },
    // {
    //   id: 2,
    //   src: bg2,
    // repeat:true,
    // },
    // {
    //   id: 3,
    //   src: bg3,
    // repeat:true,
    // },
    // {
    //   id: 4,
    //   src: bg4,
    // repeat:true,
    // },
    // {
    //   id: 5,
    //   src: bg5,
    // repeat:true,
    // },
    // {
    //   id: 6,
    //   src: bg6,
    // repeat:true,
    // },
    // {
    //   id: 7,
    //   src: bg7,
    // repeat:true,
    // },
    // {
    //   id: 8,
    //   src: bg8,
    // repeat:true,
    // },
    // {
    //   id: 9,
    //   src: bg9,
    // repeat:true,
    // },
    // {
    //   id: 10,
    //   src: bg10,
    // repeat:true,
    // },
    {
      id: 11,
      src: bg11,
      repeat: true,
      cover: false,
    },
    // {
    //   id: 12,
    //   src: bg12,
    //   repeat: true,
    // },
    {
      id: 13,
      src: bg13,
      repeat: true,
      cover: false,
    },
    {
      id: 14,
      src: bg14,
      repeat: true,
      cover: false,
    },
    {
      id: 15,
      src: bg15,
      repeat: true,
      cover: false,
    },
    {
      id: 16,
      src: bg16,
      repeat: false,
      cover: false,
    },
    {
      id: 17,
      src: bg17,
      repeat: false,
      cover: false,
    },
    {
      id: 18,
      src: bg18,
      repeat: false,
      cover: false,
    },
    // {
    //   id: 19,
    //   src: bg19,
    //   repeat: true,
    // },
    {
      id: 20,
      src: bg20,
      repeat: true,
      cover: false,
    },
    // {
    //   id: 21,
    //   src: bg21,
    //   repeat: true,
    // },
    // {
    //   id: 22,
    //   src: bg22,
    //   repeat: true,
    // },
    {
      id: 23,
      src: bg23,
      repeat: true,
      cover: false,
    },
    {
      id: 24,
      src: bg24,
      repeat: true,
      cover: false,
    },
    {
      id: 25,
      src: bg25,
      repeat: false,
      cover: true,
    },
    {
      id: 26,
      src: bg26,
      repeat: false,
      cover: true,
    },
    {
      id: 27,
      src: bg27,
      repeat: false,
      cover: true,
    },
    {
      id: 28,
      src: bg28,
      repeat: false,
      cover: true,
    },
    {
      id: 29,
      src: bg29,
      repeat: false,
      cover: true,
    },
    {
      id: 30,
      src: bg30,
      repeat: true,
      cover: false,
    },
    {
      id: 31,
      src: bg31,
      repeat: true,
      cover: false,
    },
    {
      id: 32,
      src: bg32,
      repeat: true,
      cover: false,
    },
    {
      id: 33,
      src: bg33,
      repeat: true,
      cover: true,
    },
    {
      id: 34,
      src: bg34,
      repeat: true,
      cover: true,
    },
    {
      id: 35,
      src: bg35,
      repeat: true,
      cover: false,
    },
    {
      id: 36,
      src: bg36,
      repeat: true,
      cover: false,
    },
  ],
};
export default backgrounds;
